export const messages = {
  en: {
    websiteAccessLogManage: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      logIdPlaceholder: 'Please enter log ID',
      ipPlaceholder: 'Please enter IP address',
      accessUrlPlaceholder: 'Please enter access URL',
      loginStatePlaceholder: 'Please select login status',
      query: 'Query',
      logInfo: 'Website Access Log Information',
      logId: 'Log ID',
      ip: 'IP Address',
      accessTime: 'Access Time',
      accessUrl: 'Access URL',
      loginState: 'Login Status',
      loginName: 'Login Name',
      notLogin: 'Not Logged In',
      loggedIn: 'Logged In'
    }
  },
  zh: {
    websiteAccessLogManage: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      logIdPlaceholder: '请输入日志ID',
      ipPlaceholder: '请输入访问IP',
      accessUrlPlaceholder: '请输入访问URL',
      loginStatePlaceholder: '请选择登录状态',
      query: '查询',
      logInfo: '网站访问日志信息',
      logId: '日志ID',
      ip: '访问IP',
      accessTime: '访问时间',
      accessUrl: '访问URL',
      loginState: '登录状态',
      loginName: '登录人名称',
      notLogin: '未登录',
      loggedIn: '已登录'
    }
  }
}